import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './styles/theme';
import App from './App';
import './styles/global.css';

// Установка значения API URL по умолчанию
if (!import.meta.env.VITE_API_URL) {
  (window as unknown as { VITE_API_URL: string }).VITE_API_URL =
    'http://localhost:8001';
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
